export default `
<!-- Old AngularJS component (flag OFF) -->
<academy-course
  ng-if="!$ctrl.useRedesign"
  course-track="$ctrl.courseTrack"
  user="$ctrl.user">
</academy-course>

<!-- New Angular 14 component (flag ON) -->
<ut-course-page
  ng-if="$ctrl.useRedesign"
  [course-track]="$ctrl.courseTrack"
  [user]="$ctrl.user"
  [use-redesign-catalog]="$ctrl.useRedesignCatalog">
</ut-course-page>
`;
